import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Icon from './Icon';
import { PurposePills } from './EventTags';
import './CheerCard.css';

/* One cheer, drawn the same way wherever it appears — the feed, the receiver's inbox, a profile.
   F7.

   ★ ONE component on three screens, for the reason `EventSocial` and `CommunityWall` are each one
   component on two: three renderings of one thing drift, and the one nobody checks is the one
   that goes wrong.

   ★ The lead line names both people and the WORDS are the card. Not "Ana recognised Ben for Win
   Together" as a sentence — with up to three chips that becomes a paragraph of nouns. The chips
   sit under the sentence carrying their own colours (the company's for a theme or a value, the
   UN's own for a goal), so a row of three reads as three groups without a label on each. */

const Face = ({ person }) => (
  person?.photo_url
    ? <img src={person.photo_url} alt="" className="cc-face" />
    : <span className="cc-face cc-face--blank"><Icon name="user" /></span>
);

const CheerCard = ({ cheer, children, className = '', linkTo = null }) => {
  const { t } = useTranslation();
  if (!cheer) return null;

  const lead = t('cheerLead', { from: cheer.from?.name || '', to: cheer.to?.name || '' });
  const body = (
    <>
      <div className="cc-head">
        <Face person={cheer.from} />
        <Icon name="hands-clapping" className="cc-arrow" />
        <Face person={cheer.to} />
        <span className="cc-lead">{lead}</span>
      </div>
      <p className="cc-body">{cheer.body}</p>
      <PurposePills items={cheer.purposes} className="cc-chips" />
    </>
  );

  return (
    <div className={`cc ${className}`}>
      {/* A whole-card link only where there is somewhere to go. Never a <button> wrapping a
          <Link> — invalid markup that fires both. */}
      {linkTo ? <Link to={linkTo} className="cc-link">{body}</Link> : body}
      {children}
    </div>
  );
};

export default CheerCard;
